import { Button, Classes, Tooltip } from '@blueprintjs/core';
import { mdiPlus } from '@mdi/js';
import Icon from '@mdi/react';
import { boundMethod } from 'autobind-decorator';
import classNames from 'classnames';
import React, { Component, Fragment } from 'react';
import { t } from 'ttag';

import { ProjectId } from 'uf/projects';
import { AnnotatedLayerReference } from 'uf/projects/selectors/availableLayers';
import textStyles from 'uf/styles/text.module.css';
import { IconSizeNew } from 'uf/ui/base/icon';
import LayerManagerDialog from 'uf/ui/layers/LayerManager/LayerManagerDialog/LayerManagerDialog';

interface LayerManagerButtonProps {
  projectId?: ProjectId;
  restrictedLayerIds?: string[];
  getAddRemoveTooltipText?: (LayerReference: AnnotatedLayerReference) => {
    addText: string;
    removeText: string;
  };
}

interface LayerManagerButtonState {
  show: boolean;
}

export default class LayerManagerButton extends Component<
  LayerManagerButtonProps,
  LayerManagerButtonState
> {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }

  @boundMethod
  openDialog() {
    this.setState({ show: true });
  }

  @boundMethod
  closeDialog() {
    this.setState({ show: false });
  }

  render() {
    const { projectId, restrictedLayerIds, getAddRemoveTooltipText } =
      this.props;
    const { show } = this.state;

    const buttonClass = classNames(
      'LayerManager',
      textStyles.lightText,
      Classes.INTENT_PRIMARY,
    );

    return (
      <Fragment>
        <Tooltip content={t`Add a layer`}>
          <Button
            className={buttonClass}
            icon={
              <Icon
                path={mdiPlus}
                size={IconSizeNew.EXTRA_SMALL}
                className={textStyles.lightText}
              />
            }
            small
            onClick={this.openDialog}>
            {t`Add`}
          </Button>
        </Tooltip>
        <LayerManagerDialog
          projectId={projectId}
          restrictedLayerIds={restrictedLayerIds}
          getAddRemoveTooltipText={getAddRemoveTooltipText}
          show={show}
          onOk={this.closeDialog}
        />
      </Fragment>
    );
  }
}
